import { useState, useEffect } from 'react';
import { getUserPermissions, hasPermission, hasAnyPermission, hasAllPermissions, canAccessSection, canPerformAction } from '@/shared/utils/permissions';

/**
 * Hook to check user permissions
 * @returns {object} Permission checking functions
 */
export function usePermissions() {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    // Update permissions when token changes
    const updatePermissions = () => {
      setPermissions(getUserPermissions());
    };

    updatePermissions();

    // Listen for storage changes (e.g., login/logout)
    const handleStorageChange = (e) => {
      if (e.key === 'access_token') {
        updatePermissions();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically (in case token is updated in same window)
    const interval = setInterval(updatePermissions, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return {
    permissions,
    hasPermission: (permission) => hasPermission(permission),
    hasAnyPermission: (permissionList) => hasAnyPermission(permissionList),
    hasAllPermissions: (permissionList) => hasAllPermissions(permissionList),
    canAccessSection: (section) => canAccessSection(section),
    canPerformAction: (resource, action) => canPerformAction(resource, action),
  };
}

export default usePermissions;




